/**
 * All feature flags used in the algodash application.
 *
 * Add new feature flags here as string literal types.
 * This provides type safety when checking feature flags throughout the app.
 */
export const FeatureFlags = {
  OPTION_STOP_ORDERS: "option_stop_orders",
  CRYPTO_TRC: "crypto-trc",
  ACH_LINKABLE_LEGAL_ENTITIES: "ach-linkable-legal-entities",
  FPSL_COUNTRY_CHECK_BYPASS: "fpsl-country-check-bypass-account-whitelist",
  IRA_CONTRIBUTIONS_CARD: "ira-contributions-card",
  IRA_WITHDRAWALS: "ira-account-withdrawals",
  ONFIDO_WORKFLOW_STUDIO: "kyc-onfido-workflow",
  MAINTENANCE_WINDOW_DISABLED: "maintenance-window-disabled",
  MARKET_DATA_BANK_ACCOUNT_PAYMENT: "market-data-bank-account-payment",
  TOKENIZED_EQUITY_TRADING: "tokenized-equity-trading",
  ADVANCED_TRADING_DASHBOARD: "advanced-trading-dashboard",
} as const;

/**
 * Union type of all valid feature flag names.
 */
export type FeatureFlagName = (typeof FeatureFlags)[keyof typeof FeatureFlags];
